import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "side-menu opacity-0 bg-custom-secondary",
  style: {"background-image":"url(/fe/asset/img/Rectangle.png)","background-size":"cover","border-radius":"30px 0px 0px 30px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_3 = { class: "inner-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "btn-close",
  id: "btn_sideNavClose"
}, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("i")
], -1)
const _hoisted_5 = { class: "side-nav w-100" }
const _hoisted_6 = { class: "navbar-nav" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<li class=\"nav-item\"><a class=\"nav-link\" href=\"/\">Beranda</a></li><li class=\"nav-item\"><a class=\"nav-link collapsePagesSideMenu\" data-toggle=\"collapse\" href=\"#sideNavPages1\"> Layanan <i class=\"fas fa-chevron-down\"></i></a><div id=\"sideNavPages1\" class=\"collapse sideNavPages\"><ul class=\"navbar-nav mt-2\"><li class=\"nav-item\"><a class=\"nav-link\" href=\"/layanan-permohonan-daya\">Dukungan Daya Sementara</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"/layanan-iuptl\">Pelaporan IUPTLS/IUPTLU/IUJPTL</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"/layanan-suket\">Permohonan Surat Keterangan</a></li></ul></div></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"/sebaran-spklu\">Peta SPKL</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"/peraturan\">Peraturan</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"\">FAQ</a></li>", 5)
const _hoisted_12 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "/login",
  class: "nav-link btn btn-warning btn-sm bg-custom w-100 fw-bold"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, " Masuk / Daftar ")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link collapsePagesSideMenu btn btn-warning btn-sm bg-custom w-100 fw-bold",
  "data-toggle": "collapse",
  href: "#sideNavPages22"
}, [
  /*#__PURE__*/_createTextVNode(" Dashboard Saya "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down" })
], -1)
const _hoisted_17 = {
  id: "sideNavPages22",
  class: "collapse sideNavPages"
}
const _hoisted_18 = { class: "navbar-nav mt-2" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"side-footer w-100\"><ul class=\"social-icons-simple white top40\"><li><a href=\"javascript:void(0)\" class=\"facebook\"><i class=\"fab fa-facebook-f\"></i></a></li><li><a href=\"javascript:void(0)\" class=\"twitter\"><i class=\"fab fa-twitter\"></i></a></li><li><a href=\"javascript:void(0)\" class=\"insta\"><i class=\"fab fa-instagram\"></i></a></li></ul><p class=\"whitecolor\">© © 2023 Pemerintah Provinsi DKI Jakarta</p></div>", 1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  id: "close_side_menu",
  class: "tooltip"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("nav", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _hoisted_7,
            (!_ctx.authStore.isAuthenticated)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, _hoisted_14))
              : (_openBlock(), _createElementBlock("li", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("ul", _hoisted_18, [
                      _createElementVNode("li", _hoisted_19, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          href: "javascript:void(0)",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDashboard && _ctx.goToDashboard(...args)))
                        }, "Dashboard")
                      ]),
                      _createElementVNode("li", _hoisted_20, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          href: "javascript:void(0)",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args)))
                        }, "Profil")
                      ]),
                      _createElementVNode("li", _hoisted_21, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          href: "javascript:void(0)",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                        }, "Logout")
                      ])
                    ])
                  ])
                ]))
          ])
        ]),
        _hoisted_22
      ])
    ]),
    _hoisted_23
  ], 64))
}